import React, { Component } from "react";

class PasswordModal extends Component {

	constructor(props) {
		super(props);
		this.input_password = React.createRef();  
	}

    render() {
        return (
            <div className="modal is-active">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">{this.props.title}</p>
                        <button className="delete" aria-label="close"  onClick={this.props.onClose}></button>
                    </header>
                    <section className="modal-card-body">
                        <input className="input" type="text" placeholder="Password" ref={this.input_password}/>
                    </section>
                    <footer className="modal-card-foot" style={{ justifyContent: "flex-end" }}>
                        <button  onClick={()=>(this.props.onClick(this.input_password.current.value))} className="button is-primary">Do it</button>
                    </footer>
                </div>
                <button className="modal-close is-large" aria-label="close" onClick={this.props.onClose}></button>
            </div>
        );
    }
}

export default PasswordModal;